import { ButtonWrapper } from "./styled"
import Tippy from '@tippyjs/react/headless';

const ButtonIcon = ({ icon, classIcon, classButton, classText, isNa = false, description, className, children, ...props }) => {
    return (
        <div >
            {
                description &&

                <Tippy
                    interactive
                    placement='bottom'
                    render={attrs => (
                        <div style={{ backgroundColor: '#666', borderRadius: '4px', padding: '4px 8px' }}>
                            <p style={{ color: 'white', fontSize: '0.9rem', margin: '0' }}>{description}</p>
                        </div>
                    )}
                >
                    <ButtonWrapper
                        className={classButton}
                        disabled={isNa} style={isNa ? { cursor: "not-allowed" } : { cursor: "pointer" }}
                        {...props}
                    >
                        <i className={classIcon}>{icon}</i>
                        <span className={classText}> {children}</span>
                    </ButtonWrapper>
                </Tippy >
            }
            {
                !description &&
                <ButtonWrapper
                    className={classButton}
                    disabled={isNa} style={isNa ? { cursor: "not-allowed" } : { cursor: "pointer" }}
                    {...props}
                >
                    <i className={classIcon}>{icon}</i>
                    <span className={classText}> {children}</span>
                </ButtonWrapper>
            }
        </div >
    )
}

export default ButtonIcon